import * as React from "react";

const BancAvatarIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="54.304"
    height="54.304"
    viewBox="0 0 54.304 54.304"
  >
    <defs>
      <linearGradient
        id="linear-gradient-icon"
        x1="0.596"
        x2="0.596"
        y1="1.13"
        y2="-0.048"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#eaf2ff"></stop>
        <stop offset="1" stopColor="#9bbaff"></stop>
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-icon"
        id="linear-gradient-icon-2"
        x1="0.596"
        x2="0.596"
        y1="1.13"
        y2="-0.048"
      ></linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-icon"
        id="linear-gradient-icon-3"
        x1="0.596"
        x2="0.596"
        y1="1.13"
        y2="-0.048"
      ></linearGradient>
      <linearGradient
        id="linear-gradient-icon-4"
        x1="0.5"
        x2="0.5"
        y1="0.019"
        y2="0.936"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#0cc8ef"></stop>
        <stop offset="1" stopColor="#047afa"></stop>
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-icon-4"
        id="linear-gradient-icon-5"
        x1="0.5"
        x2="0.5"
        y1="-0.085"
        y2="1"
      ></linearGradient>
    </defs>
    <g
      id="Bank_Icon"
      data-name="Bank Icon"
      transform="translate(98.943 98.941)"
    >
      <path
        id="Tracé_7862"
        fill="#eef6ff"
        d="M52.662 13.772c-1.425-5.247-6.882-10.7-12.13-12.13A54 54 0 0 0 27.152 0a54 54 0 0 0-13.38 1.642c-5.247 1.425-10.7 6.882-12.13 12.13A54 54 0 0 0 0 27.152a54 54 0 0 0 1.642 13.38c1.425 5.248 6.883 10.7 12.13 12.13a54 54 0 0 0 13.38 1.638 54 54 0 0 0 13.38-1.642c5.248-1.425 10.7-6.882 12.13-12.13A54 54 0 0 0 54.3 27.152a54 54 0 0 0-1.638-13.38"
        data-name="Tracé 7862"
        transform="translate(-98.943 -98.941)"
      ></path>
      <path
        id="rect15734"
        fill="url(#linear-gradient-icon)"
        d="M3.7 13.527h6.426V28.9H3.7Z"
        opacity="0.998"
        transform="translate(-89.275 -88.837)"
      ></path>
      <path
        id="path15761"
        fill="url(#linear-gradient-icon-2)"
        d="M24.011 13.527h6.426V28.9h-6.426Z"
        opacity="0.998"
        transform="translate(-88.368 -88.837)"
      ></path>
      <path
        id="path15765"
        fill="url(#linear-gradient-icon-3)"
        d="M13.858 13.527h6.426V28.9h-6.426Z"
        opacity="0.998"
        transform="translate(-88.822 -88.837)"
      ></path>
      <path
        id="path15567"
        fill="url(#linear-gradient-icon-4)"
        d="M17.644 1.058a3.84 3.84 0 0 0-2.023.7L1.976 11.166c-1.664 1.071-.858 3.686.73 3.686h29.876c1.588 0 2.394-2.616.73-3.686L19.667 1.759a3.84 3.84 0 0 0-2.023-.7Z"
        opacity="0.998"
        transform="translate(-89.394 -89.394)"
      ></path>
      <path
        id="rect15725"
        fill="url(#linear-gradient-icon-5)"
        d="M2.993 27.384h29.3a1.93 1.93 0 0 1 1.935 1.935v1.8a1.93 1.93 0 0 1-1.935 1.935h-29.3a1.93 1.93 0 0 1-1.935-1.935v-1.8a1.93 1.93 0 0 1 1.935-1.935"
        opacity="0.998"
        transform="translate(-89.394 -88.218)"
      ></path>
      <path
        id="path15769"
        fill="#eaf2ff"
        d="M20.194 6.852a3.127 3.127 0 1 0-3.127 3.127 3.127 3.127 0 0 0 3.127-3.127"
        transform="translate(-88.818 -89.274)"
      ></path>
      <path
        id="path3166"
        fill="#024292"
        d="M2.117 11.972v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.383 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.381 0v.275H8.2v-.275Zm1.383 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.383 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.383 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.383 0v.275h.553v-.275Zm1.381 0v.275h.558v-.275Zm1.381 0v.275h.553v-.275Zm1.383 0v.275h.551v-.275Zm1.381 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Zm1.383 0v.275h.551v-.275Zm1.381 0v.275h.553v-.275Zm1.381 0v.275h.553v-.275Z"
        transform="translate(-89.346 -88.906)"
      ></path>
    </g>
  </svg>
);

export default BancAvatarIcon;
